"use strict";import{tag as a}from"../custom-tag.js";export function leafIcon({height:e=16,width:t=16,hidden:r=!1,title:l="Leaf"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 22 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M0 8.207C0 3.674 3.705 0 8.275 0H22v15.793C22 20.326 18.295 24 13.725 24H0z"
      />
    </svg>
  `}
//# sourceMappingURL=leaf.js.map
